import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { FaArrowRight } from "react-icons/fa";

function TemplatesPage() {
  const navigate = useNavigate();

  return (
    <div className="p-10 bg-gray-900 min-h-screen text-white">
      <h1 className="text-3xl font-bold text-yellow-400 mb-6 text-center">
        ✍️ إنشاء عقد جديد مخصص
      </h1>

      <p className="text-center mb-10 text-gray-300 text-lg">
        يمكنك كمحامي إنشاء نموذج قانوني مخصص، حفظه، ثم استخدامه لاحقًا لتوليد عقود كاملة
        باستخدام الصيغ والمتغيرات الذكية.
      </p>

      <div className="flex justify-center">
        <motion.button
          onClick={() => navigate("/templates-manager")}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.97 }}
          className="bg-yellow-400 text-black px-8 py-3 rounded-lg font-bold flex items-center gap-2 hover:bg-yellow-300 transition"
        >
          <FaArrowRight />
          ابدأ تصميم عقد جديد
        </motion.button>
      </div>
    </div>
  );
}

export default TemplatesPage;
